import { ReactQueryDevtools } from 'react-query/devtools';
import { FC, ReactElement } from 'react';

const DevTools: FC = (): ReactElement | null => {
  if (process.env.NODE_ENV === 'production') return null;
  return <ReactQueryDevtools initialIsOpen={false} />;
};

export default DevTools;
